import React from 'react';
import { Wallet } from 'lucide-react';
import { Button } from '../ui/button';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui/tabs';
import { useToast } from '../../hooks/use-toast';
import { payroll } from '../../api';
import { EmployeesTab } from './EmployeesTab';
import { PayRunsTab } from './PayRunsTab';
import { Emp201Tab, Emp501Tab } from './TaxTabs';
import { TakeOnTab } from './TakeOnTab';
import { LeaveTab } from './LeaveTab';

export const PayrollPanel = ({ client, onEnabled }) => {
  const { toast } = useToast();
  if (!client.payrollEnabled) {
    return (
      <div className="rounded-xl bg-white border border-stone-200 p-10 text-center" data-testid="payroll-disabled">
        <Wallet size={28} className="mx-auto text-emerald-800"/>
        <div className="mt-3 font-semibold text-stone-900">Payroll isn&apos;t switched on for {client.name}</div>
        <p className="mt-1 text-sm text-stone-600">Turn it on to add employees, run monthly, weekly or fortnightly payslips, and produce EMP201, EMP501 and IRP5s.</p>
        <Button className="mt-5 bg-emerald-800 hover:bg-emerald-900 text-white" onClick={() => payroll.enable(client.id, true).then(() => { toast({ title: 'Payroll enabled' }); onEnabled?.(); })} data-testid="enable-payroll-btn">Run payroll for this client</Button>
      </div>
    );
  }
  return (
    <div data-testid={`payroll-panel-${client.id}`}>
      {!client.payeNumber && <div className="mb-4 rounded-lg bg-amber-50 border border-amber-200 px-4 py-2.5 text-sm text-amber-900" data-testid="payroll-no-paye-warning">No PAYE reference number on this client. Add it in Edit client so it prints on EMP201s and IRP5s.</div>}
      <Tabs defaultValue="runs">
        <TabsList data-testid="payroll-tabs">
          <TabsTrigger value="runs" data-testid="payroll-tab-runs">Pay runs</TabsTrigger>
          <TabsTrigger value="employees" data-testid="payroll-tab-employees">Employees</TabsTrigger>
          <TabsTrigger value="leave" data-testid="payroll-tab-leave">Leave</TabsTrigger>
          <TabsTrigger value="emp201" data-testid="payroll-tab-emp201">EMP201</TabsTrigger>
          <TabsTrigger value="emp501" data-testid="payroll-tab-emp501">EMP501 & IRP5</TabsTrigger>
          <TabsTrigger value="takeon" data-testid="payroll-tab-takeon">Take-on balances</TabsTrigger>
        </TabsList>
        <TabsContent value="runs" className="mt-5"><PayRunsTab clientId={client.id} toast={toast}/></TabsContent>
        <TabsContent value="employees" className="mt-5"><EmployeesTab clientId={client.id} toast={toast}/></TabsContent>
        <TabsContent value="leave" className="mt-5"><LeaveTab clientId={client.id} toast={toast}/></TabsContent>
        <TabsContent value="emp201" className="mt-5"><Emp201Tab clientId={client.id}/></TabsContent>
        <TabsContent value="emp501" className="mt-5"><Emp501Tab clientId={client.id}/></TabsContent>
        <TabsContent value="takeon" className="mt-5"><TakeOnTab clientId={client.id} toast={toast}/></TabsContent>
      </Tabs>
    </div>
  );
};
